/* istanbul ignore file - better tested e2e */

import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { CreateInstructionsPage } from './create';
import { ManageInstructionsPage } from './manage';
import { InstructionsPage } from './root';
import { StepBuilderPage } from './step-builder/StepBuilderPage';
import { ViewInstructionsPage } from './viewer';

export function InstructionsPageRouter() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <InstructionsPage />
      </Route>
      <Route path={`${path}/create`}>
        <CreateInstructionsPage />
      </Route>
      <Route path={`${path}/manage/:configurationId`}>
        <ManageInstructionsPage />
      </Route>
      <Route path={`${path}/viewer/:configurationId`}>
        <ViewInstructionsPage />
      </Route>
      <Route path={`${path}/step-builder/:configurationId/:instructionId/:versionId/:segmentId`}>
        <StepBuilderPage />
      </Route>
    </Switch>
  );
}
